import { Button, DatePicker, Message, Modal, Space, Upload } from "@arco-design/web-react";
import { useState } from "react";
import OperationButton from "@/components/OperationButton";
import { ItemAPI } from "@/apis/material";
import { baseUrl } from "@/utils/api";
import { IconBook, IconUpload } from "@arco-design/web-react/icon";
import { EditableTable } from "@/components/EditableTable";

const ItemDocButton = ({ itemId }) => {
    const [data, setData] = useState([]);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    const getDocs = async () => {
        let docs = await ItemAPI.getDocuments(itemId);
        setData(docs);
    }

    const afterDocUpload = (files, file) => {
        switch (file.status) {
            case "error":
                setConfirmLoading(false);
                Message.error("Document upload failed");
                break;
            case "done":
                setConfirmLoading(false);
                getDocs();
                Message.success("Document upload successfully");
                break;
            default:
                break;
        }
    }

    const updateDoc = async (row) => {
        await ItemAPI.updateDocument(row.id, row);
        Message.success("Document updated successfully");
        getDocs();
    }

    const deleteDoc = async (id) => {
        await ItemAPI.deleteDocument(id);
        Message.success("Document deleted successfully");
        setData(data.filter(item => item.id !== id));
    }

    const columns = [
        { title: "Name", dataIndex: "document.docName" },
        {
            title: "Expiration Date", dataIndex: "expiredDate",
            editableRender: (col, record) => (
                <DatePicker style={{ width: 200 }} />
            )
        },
    ];

    return (
        <>
            <OperationButton icon={<IconBook />} label="Documents"
                onClick={() => {
                    getDocs();
                    setVisible(true);
                }} />
            <Modal title="Item Documents" visible={visible}
                style={{ width: 700 }}
                onCancel={() => setVisible(false)}
                footer={
                    <Space>
                        <Button onClick={() => setVisible(false)}>Close</Button>
                        <Upload withCredentials={true} showUploadList={null}
                            action={`${baseUrl}/item/document?itemId=${itemId}`}
                            headers={{ 'bee-access-token': localStorage.getItem("login.token") }}
                            beforeUpload={() => setConfirmLoading(true)}
                            onChange={afterDocUpload}>
                            <Button type="primary" icon={<IconUpload />}
                                loading={confirmLoading}>Upload Document</Button>
                        </Upload>
                    </Space>
                }
            >
                <EditableTable columns={columns} data={data} rowKey="id"
                    onRowDelete={row => deleteDoc(row.id)}
                    onRowSave={updateDoc}></EditableTable>
            </Modal >
        </>
    );
}

export default ItemDocButton;